import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Paginate from "../../shared/Paginate";
import MovieList from "../../shared/MovieList/MovieList";

import { MoviesData } from "src/types/movieData";
import Loader from "src/shared/Loader";
import { getMoviesList } from "src/shared/api";

const PopularMovies = () => {
  const [data, setData] = useState<MoviesData | null>(null);

  let { currentPage } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getMoviesList("popular", currentPage as string).then((response) =>
      setData(response.data),
    );
  }, [currentPage]);

  const handlePageChange = (selectedNumber: { selected: number }) => {
    navigate(`/popularmovies/${selectedNumber.selected + 1}`);
  };

  if (!data) {
    return <Loader />;
  }

  return (
    <div>
      <MovieList movies={data.results} />

      <Paginate onPageChange={handlePageChange} pageCount={data.total_pages} />
    </div>
  );
};

export default PopularMovies;
